import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, Card, CardContainer, DatePicker, getSpacing, Picker, TextInput, TextView } from '@rahtab/ui';
import { Screen, StackScreenProps } from '@rahtab/stack-navigator';
import { useAnounceDelivery } from 'hooks/InventoryHooks/useAnounceDelivery';
import { RootStackType } from '../Router';
import { useEffect } from 'react';
import { withNumbers, withSeparator } from '@rahtab/system/lib/tools/string';
import moment from 'moment-jalaali';

const DATE_FORMAT = 'YYYY/MM/DD';
const DISPLAY_DATE_FORMAT = 'jYYYY/jMM/jDD';

const confirmationOptions = [
  {
    label: 'اطلاعات بار دریافتی اعلام شده مورد تایید است.',
    value: 'true',
  },
  {
    label: 'اطلاعات بار دریافتی اعلام شده مورد تایید نیست.',
    value: 'false',
  },
];

const AnounceLoadDelivery: React.VFC<AnounceLoadDeliveryProps> = ({ route }) => {
  const { assignFinalCode, merchandiseId } = route.params;
  const [date, setDate] = useState(moment().format(DATE_FORMAT));
  const [confirmationState, setConfirmationState] = useState('true');
  const [amount, setAmount] = useState('');
  const [unitPrice, setUnitPrice] = useState('');
  const [selected, setSelected] = useState('');
  useEffect(() => {
    if (confirmationState === 'false') {
      setAmount('');
      setUnitPrice('');
    }
  }, [confirmationState]);
  const disableAnounceButton = () => {
    if (confirmationState === 'true') {
      if (!date) {
        return true;
      }
    } else {
      if (!(date && amount && unitPrice)) {
        return true;
      }
    }
    return false;
  };
  const { loading, anounce } = useAnounceDelivery({
    assignFinalCode,
    date,
    receiveAmount: amount,
    merchandiseId,
    receiveComment: '',
    receiveMatch: confirmationState === 'true',
    receivePricePerUnit: unitPrice,
    receiveTotalPrice: (parseFloat(amount) * parseFloat(unitPrice)).toString(),
  });
  const calculatePrice = (): string => {
    const parsedAmount = parseFloat(amount);
    const parsedUnitPrice = parseFloat(unitPrice);
    if (!amount || !unitPrice || isNaN(parsedAmount) || isNaN(parsedUnitPrice)) {
      return '0 تومان';
    } else {
      return `${withSeparator(parsedAmount * parsedUnitPrice)} تومان`;
    }
  };
  return (
    <Screen
      transparentLoading={loading}
      title="اعلام وصول بار دریافتی"
      renderMain={() => {
        return (
          <>
            <Card style={StyleSheet.flatten([styles.card])}>
              <CardContainer>
                <DatePicker
                  label="تاریخ تحویل بار"
                  onConfirm={setDate}
                  format={DATE_FORMAT}
                  displayFormat={DISPLAY_DATE_FORMAT}
                  value={date}
                  placeholder="تاریخ تحویل بار را انتخاب نمایید."
                />
                <Picker selectedValue={confirmationState} onSelectValue={setConfirmationState}>
                  {confirmationOptions.map((option, index) => {
                    return <Picker.Item {...option} key={index} />;
                  })}
                </Picker>
                {confirmationState === 'false' && (
                  <>
                    <TextInput
                      placeholder="مقدار بار اعلام شده را وارد نمایید."
                      label="مقدار بار اعلام شده"
                      onChangeText={withNumbers(setAmount)}
                      value={amount}
                      returnKeyType="next"
                      keyboardType="numeric"
                      onSubmitEditing={() => {
                        setSelected('unitPrice');
                      }}
                    />

                    <TextInput
                      placeholder="قیمت واحد اعلام شده را وارد نمایید."
                      label="قیمت واحد اعلام شده"
                      onChangeText={withNumbers(setUnitPrice)}
                      value={unitPrice}
                      returnKeyType="done"
                      keyboardType="numeric"
                      selected={selected === 'unitPrice'}
                      onBlur={() => {
                        setSelected('');
                      }}
                    />
                    <TextView title="ارزش ریالی بار دریافتی" value={calculatePrice()} />
                  </>
                )}
                <Button
                  disabled={disableAnounceButton()}
                  onPress={anounce}
                  text="اعلام وصول بار دریافتی"
                  color="primary"
                />
              </CardContainer>
            </Card>
          </>
        );
      }}
    />
  );
};

export default AnounceLoadDelivery;

const styles = StyleSheet.create({
  card: {
    marginHorizontal: getSpacing(),
    marginVertical: getSpacing(),
  },
});

type AnounceLoadDeliveryProps = StackScreenProps<RootStackType, 'AnounceLoadDelivery'>;
